import DataFetcher from './data_fetcher';

const fetcher = new DataFetcher();

export default fetcher;
